import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const CurriculumGuide: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">Curriculum Guide</Typography>
                <Typography variant="body1" paragraph>
                    Our platform is aligned with the standard national curriculum. Here is how we structure the learning content:
                </Typography>
                <Typography variant="h6" gutterBottom>Levels</Typography>
                <Typography variant="body1" paragraph>
                    Courses are divided into standard levels (e.g., National 5, Higher, Advanced Higher).
                </Typography>
                <Typography variant="h6" gutterBottom>Subjects & Areas</Typography>
                <Typography variant="body1" paragraph>
                    Each subject is broken down into key Areas (e.g., Algebra, Geometry).
                </Typography>
                <Typography variant="h6" gutterBottom>Topics</Typography>
                <Typography variant="body1" paragraph>
                    Areas consist of bite-sized Topics, which are the fundamental units of learning you track daily.
                </Typography>
            </Paper>
        </Container>
    );
};
export default CurriculumGuide;
